import React from "react";
import { CropImageFreeWithOnline } from "./CropImageFreeWithOnline";
import CropImageFreeContent from "./CropImageFreeContent";
import CropImageFaq from "./CropImageFaq";

const CropImagePreToolsArea = () => {
    return (
        <div className="flex justify-center items-center-center content-center">
            <div className="max-w-4xl mx-5  md:mx-20">
                <CropImageFreeWithOnline />
                <CropImageFreeContent />
                <CropImageFaq />
            </div>
        </div>
    );
};

export default CropImagePreToolsArea;
